import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "category" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      formConfig: _ctx.searchFormConfig,
      onQueryBtnClick: _ctx.handleQueryClick,
      onResetBtnClick: _ctx.handleResetClick
    }, null, 8, ["formConfig", "onQueryBtnClick", "onResetBtnClick"]),
    _createVNode(_component_PageContent, {
      ref: "pageContentRef",
      pageName: "category",
      contentConfig: _ctx.contentTableConfig,
      onNewBtnClick: _ctx.handleNewData,
      onEditBtnClick: _ctx.handleEditData
    }, null, 8, ["contentConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref: "pageModalRef",
      defaultInfo: _ctx.defaultInfo,
      modalConfig: _ctx.modalConfig,
      pageName: "department"
    }, null, 8, ["defaultInfo", "modalConfig"])
  ]))
}